import { v4 as uuid } from 'uuid'
import { CampaignOption } from 'types'
import { Schedule } from 'hooks/queries/schedules/useAddToBrandPlanSchedule'
import { ContentCategory, CONTENT_CATEGORY_CONFIG } from 'utils/brandPlans/contentCategories'
import {
  computePostTimes,
  expandTopicRowsToPayload,
  getDefaultTacticsForPostType,
  POST_TYPE_TO_CONTENT_TYPE,
  storyApiTypeFromTactics,
} from '../CreateContentModal/utils'
import { ComposeRowData } from './Types'

const DEFAULT_CATEGORY: ContentCategory = 'still_image_post'

const newRow = (
  schedule: CampaignOption,
  category: ContentCategory,
  postAt: ComposeRowData['postAt'],
  isBlank: boolean,
): ComposeRowData => {
  const config = CONTENT_CATEGORY_CONFIG[category]
  return {
    id: uuid(),
    topic: '',
    postType: config.postType,
    contentCategory: category,
    tactics: getDefaultTacticsForPostType(config.postType, schedule.tactics || []),
    postAt,
    mediaFileIds: [],
    isBlank,
    referenceMedia: null,
    loading: !isBlank,
    userEdited: false,
  }
}

export const buildInitialComposeRow = (schedule: CampaignOption, isBlank: boolean): ComposeRowData => {
  const [postAt] = computePostTimes(schedule, 1)
  return newRow(schedule, DEFAULT_CATEGORY, postAt, isBlank)
}

export const appendComposeRow = (
  schedule: CampaignOption,
  existing: ComposeRowData[],
  isBlank: boolean,
): ComposeRowData => {
  const times = computePostTimes(schedule, existing.length + 1)
  const postAt = times[existing.length] ?? times[times.length - 1]
  return newRow(schedule, DEFAULT_CATEGORY, postAt, isBlank)
}

const blankRowToPayload = (row: ComposeRowData): Schedule => {
  const config = CONTENT_CATEGORY_CONFIG[row.contentCategory]
  const type =
    row.contentCategory === 'stories'
      ? storyApiTypeFromTactics(row.tactics)
      : (config.apiType as Schedule['type']) ?? POST_TYPE_TO_CONTENT_TYPE[row.postType]
  return {
    type,
    topic: '',
    caption: row.topic,
    post_at: row.postAt,
    initial_media_file_ids: row.mediaFileIds,
    tactics:
      (row.postType === 'social_post' || row.postType === 'video') && row.tactics.length > 0 ? row.tactics : undefined,
    content_type: config.contentType,
    is_blank: true,
  }
}

export const expandComposeRowsToPayload = (rows: ComposeRowData[]): Schedule[] => {
  return rows.map((row) => {
    if (row.isBlank) return blankRowToPayload(row)
    const [aiPayload] = expandTopicRowsToPayload([row])
    return { ...aiPayload, is_blank: false }
  })
}
